module.exports = __webpack_public_path__ + "img/about_us2.69d94364.png";